export interface CountryInfo {
  code: string;
  name: string;
  flag: string;
}

export const COUNTRIES: Record<string, { name: string; flag: string }> = {
  PH: { name: 'Philippines', flag: '🇵🇭' },
  US: { name: 'United States', flag: '🇺🇸' },
  CA: { name: 'Canada', flag: '🇨🇦' },
  GB: { name: 'United Kingdom', flag: '🇬🇧' },
  NG: { name: 'Nigeria', flag: '🇳🇬' },
  BR: { name: 'Brazil', flag: '🇧🇷' },
  KR: { name: 'South Korea', flag: '🇰🇷' },
  SG: { name: 'Singapore', flag: '🇸🇬' },
  AU: { name: 'Australia', flag: '🇦🇺' },
  DE: { name: 'Germany', flag: '🇩🇪' },
  GH: { name: 'Ghana', flag: '🇬🇭' },
  KE: { name: 'Kenya', flag: '🇰🇪' },
  IN: { name: 'India', flag: '🇮🇳' },
  ZA: { name: 'South Africa', flag: '🇿🇦' },
  MX: { name: 'Mexico', flag: '🇲🇽' },
  ES: { name: 'Spain', flag: '🇪🇸' },
  NZ: { name: 'New Zealand', flag: '🇳🇿' },
  JM: { name: 'Jamaica', flag: '🇯🇲' },
  UG: { name: 'Uganda', flag: '🇺🇬' },
  ZM: { name: 'Zambia', flag: '🇿🇲' },
};

export function getCountryInfo(code?: string): CountryInfo {
  if (!code) {
    return { code: 'PH', name: 'Philippines', flag: '🇵🇭' };
  }
  const upper = code.trim().toUpperCase();
  if (COUNTRIES[upper]) {
    return { code: upper, name: COUNTRIES[upper].name, flag: COUNTRIES[upper].flag };
  }
  // Try 2-letter ISO country code conversion to regional indicator symbols
  if (upper.length === 2 && /^[A-Z]{2}$/.test(upper)) {
    try {
      const codePoints = upper
        .split('')
        .map((char) => 127397 + char.charCodeAt(0));
      const flag = String.fromCodePoint(...codePoints);
      return { code: upper, name: upper, flag };
    } catch {
      return { code: upper, name: upper, flag: '🌐' };
    }
  }
  return { code: upper, name: upper, flag: '🌐' };
}
